<template>
  <div class="tw-py-28 tw-px-4 game-tile-background-color">
    <div
      class="tw-flex tw-flex-col tw-items-center tw-space-y-6 tw-text-center"
    >
      <h4 v-if="userNameId && userMuted">
        {{ $t('user_muted', { ugc: itemNameComputed }) }}
      </h4>
      <h4 v-else>{{ t('no_ugc_found', { ugc_name: itemNameComputed }) }}</h4>

      <template v-if="isFiltering">
        <base-button v-if="allowReset" primary large @click="$emit('click')">
          {{ t('reset_filters') }}
        </base-button>
      </template>
    </div>
  </div>
</template>
<script>
import { useResourceValue } from '@composables'
import { mutedUsersStore } from '@stores'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  props: {
    allowReset: {
      type: Boolean,
      default: true,
    },
    itemName: {
      validator(val) {
        return ['mod', 'game', 'collection', 'guide'].includes(val)
      },
      required: true,
    },
    isFiltering: {
      type: Boolean,
      default: false,
    },
    userNameId: {
      type: String,
      default: null,
    },
  },
  emits: ['click'],
  setup(props) {
    const { itemName, userNameId } = toRefs(props)
    const { ugcName } = useResourceValue()
    const { isUserMuted } = mutedUsersStore()
    const { t } = useI18n()

    const userMuted = isUserMuted(userNameId.value)

    const itemNameComputed = computed(() => {
      return itemName.value === 'mod'
        ? ugcName(null, false, true).value
        : `${itemName.value}s`
    })

    const addItemNameComputed = computed(() =>
      itemName.value === 'mod'
        ? ugcName(null, true, true).value
        : itemName.value
    )

    return {
      addItemNameComputed,
      itemNameComputed,
      userMuted,
      t,
    }
  },
}
</script>
